<template>
  <div class="project-panorama container">
    <h2 class="main-title">3D-тур – предоставляем к каждому объекту</h2>
    <span class="project-panorama__annotation">
      Изучите наш проект в деталях: перемещайтесь по пространству,
      рассматривайте материалы и планировку.
    </span>
    <View360
      class="is-2by1"
      :projection="projection"
      :initial-yaw="0"
      :initialZoom="0"
      :autoplay="true"
      :wheelScrollable="true"
      :rotate="{ disablePitch: true }"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

import { View360, EquirectProjection } from '@egjs/vue3-view360'

import imageUrl from '@/assets/images/main-page/360view.jpg'

export default defineComponent({
  name: 'ProjectPanorama',
  components: { View360 },
  setup() {
    const projection = ref(
      new EquirectProjection({
        src: imageUrl,
      })
    )

    return { projection }
  },
})
</script>

<style lang="scss" scoped src="./Index.scss" />
